import type { LocationDescriptor } from "history";
import { useState } from "react";
import { replace } from "react-router-redux";
import { useMount } from "react-use";

import { NotFound } from "metabase/common/components/ErrorPages";
import { connect } from "metabase/redux";
import { refreshCurrentUser } from "metabase/redux/user";
import { Center, Loader } from "metabase/ui";

type DispatchProps = {
  refreshCurrentUser: () => any;
  onChangeLocation: (location: LocationDescriptor) => void;
};

type Props = DispatchProps;

const mapDispatchToProps = {
  refreshCurrentUser,
  onChangeLocation: replace,
};

const NotFoundFallbackPageInner = ({
  refreshCurrentUser,
  onChangeLocation,
}: Props) => {
  // IAS overlay: hold rendering until we know whether the user is signed in,
  // so auth transitions (logout / SSO re-login) don't flash "We're a little
  // lost..." on their way to the real redirect target.
  const [isRefreshing, setIsRefreshing] = useState(true);

  useMount(() => {
    async function refresh() {
      const result = await refreshCurrentUser();
      const isSignedIn = !result.error;
      if (!isSignedIn) {
        onChangeLocation("/auth/login");
        return;
      }
      setIsRefreshing(false);
    }
    refresh();
  });

  if (isRefreshing) {
    return (
      <Center w="100%" h="100vh">
        <Loader size="lg" />
      </Center>
    );
  }

  return <NotFound />;
};

export const NotFoundFallbackPage = connect(
  null,
  mapDispatchToProps,
)(NotFoundFallbackPageInner);
